/**
 * Console Logger
 * Debug logger for development with configurable namespaces
 */
import debug from 'debug';
import { ENV } from '../config/env';

const log = debug('app:log');
log.log = console.log.bind(console);

const warn = debug('app:warn');
warn.log = console.warn.bind(console);

const error = debug('app:error');
error.log = console.error.bind(console);

const ga4log = debug('app:analytics:ga4');
ga4log.log = console.info.bind(console);

if (ENV === 'production') {
  debug.enable('');
} else {
  debug.enable('app:*');
}

export { log, warn, error, ga4log };
